import type { ReactNode } from 'react';

export interface TopBarProps {
  title: string;
  /** Life stage, shown capitalised next to the age. */
  stage?: string;
  age?: string;
  titleTestId?: string;
  children?: ReactNode;
}

export function TopBar({ title, stage, age, titleTestId, children }: TopBarProps) {
  return (
    <header className="top-bar">
      <h1 className="top-bar__title" data-testid={titleTestId}>
        {title}
      </h1>
      {(stage || age) && (
        <p className="top-bar__meta" data-testid="pet-meta">
          {stage && <span className="top-bar__meta-stage">{stage}</span>}
          {stage && age ? ' · ' : ''}
          {age}
        </p>
      )}
      {children && <div className="top-bar__actions">{children}</div>}
    </header>
  );
}
